import React from 'react'

function Brand({ src, alt }) {
  return (
    <div>
        <img className='w-full h-[150px] object-cover aspect-2/3 mix-blend-color-burn' src={src} alt={alt} />
    </div>
  )
}

export default Brand